
import React, { useRef, useState } from "react";
import "../styles/WhatsAppChat.css";

const WhatsAppChat = () => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const dragging = useRef(false);
  const moved = useRef(false);
  const offset = useRef({ x: 0, y: 0 });

  const phoneNumber = "919989681812"; // Techlynx Innovations WhatsApp number

  const message =
    "Hello Techlynx Innovations! I would like to know more about your services.";

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  const startDrag = (e) => {
    const point = e.touches ? e.touches[0] : e;

    const rect = buttonRef.current.getBoundingClientRect();

    dragging.current = true;
    moved.current = false;

    offset.current = {
      x: point.clientX - rect.left,
      y: point.clientY - rect.top,
    };

    buttonRef.current.style.transition = "none";

    if (e.currentTarget.setPointerCapture) {
      e.currentTarget.setPointerCapture(e.pointerId);
    }
  };

  const drag = (e) => {
    if (!dragging.current) return;

    const point = e.touches ? e.touches[0] : e;

    let x = point.clientX - offset.current.x;
    let y = point.clientY - offset.current.y;

    const button = buttonRef.current;

    const maxX = window.innerWidth - button.offsetWidth;
    const maxY = window.innerHeight - button.offsetHeight;

    x = Math.max(0, Math.min(x, maxX));
    y = Math.max(0, Math.min(y, maxY));

    if (Math.abs(x - (button.offsetLeft || 0)) > 3) {
      moved.current = true;
    }

    button.style.left = `${x}px`;
    button.style.top = `${y}px`;
    button.style.right = "auto";
    button.style.bottom = "auto";
  };

  const stopDrag = () => {
    if (!dragging.current) return;

    dragging.current = false;

    buttonRef.current.style.transition = "";

    if (!moved.current) {
      setOpen((previous) => !previous);
    }
  };

  return (
    <div className="whatsapp-widget">

      {open && (
        <div className="whatsapp-chat-box">
          <div className="whatsapp-chat-header">
            <div className="whatsapp-profile">
              <div className="whatsapp-profile-icon">W</div>

              <div>
                <strong>Techlynx Innovations</strong>
                <span>Typically replies quickly</span>
              </div>
            </div>

            <button
              className="whatsapp-close"
              onClick={() => setOpen(false)}
              aria-label="Close chat"
            >
              ×
            </button>
          </div>

          <div className="whatsapp-chat-body">
            <div className="whatsapp-message">
              👋 Hello!
              <br />
              How can we help you today?
            </div>
          </div>

          <div className="whatsapp-chat-footer">
            <a
              href={whatsappURL}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-start-chat"
            >
              <span>💬</span>
              Start Chat
            </a>
          </div>
        </div>
      )}

      <button
        ref={buttonRef}
        className="whatsapp-floating-button"
        onPointerDown={startDrag}
        onPointerMove={drag}
        onPointerUp={stopDrag}
        onPointerCancel={stopDrag}
        aria-label="WhatsApp Chat"
      >
        {open ? (
          <span className="whatsapp-x">×</span>
        ) : (
          <svg
            viewBox="0 0 32 32"
            className="whatsapp-svg"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M16.02 3.2C8.96 3.2 3.22 8.94 3.22 16c0 2.26.59 4.46 1.71 6.4L3.1 28.8l6.58-1.73a12.8 12.8 0 0 0 6.34 1.67h.01c7.06 0 12.8-5.74 12.8-12.8S23.08 3.2 16.02 3.2Zm0 23.4h-.01a10.6 10.6 0 0 1-5.4-1.47l-.39-.23-3.9 1.02 1.04-3.8-.25-.39a10.57 10.57 0 1 1 8.91 4.87Zm5.82-7.92c-.32-.16-1.9-.94-2.19-1.05-.29-.11-.5-.16-.71.16-.21.32-.81 1.05-.99 1.26-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.77-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.25-.61-.51-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.1 1.07-1.1 2.61s1.13 3.03 1.29 3.24c.16.21 2.21 3.37 5.36 4.73.75.32 1.34.51 1.8.65.76.24 1.45.2 2 .12.61-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.14-.29-.22-.61-.38Z"
            />
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppChat;

